import { motion } from "framer-motion";

export default function PolitiqueConfidentialitePage() {
  return (
    <div className="pt-20" data-testid="politique-confidentialite-page">
      <section className="bg-[#F8F9FA] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-[#333333] mb-8">Politique de Confidentialité</h1>
            
            <div className="bg-white p-8 rounded-sm shadow-sm space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">1. Introduction</h2>
                <p className="text-[#64748B] leading-relaxed">
                  QUALIDECO, située au 306 rue Ampère, 71000 Mâcon, s'engage à protéger la vie privée des utilisateurs de son site internet quali-deco.fr. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">2. Responsable du traitement</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Le responsable du traitement des données personnelles est :<br />
                  <strong>QUALIDECO</strong><br />
                  306 rue Ampère, 71000 Mâcon<br />
                  Email : qualideco@quali-deco.fr<br />
                  Téléphone : 03 85 39 29 38
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">3. Données collectées</h2>
                <p className="text-[#64748B] leading-relaxed mb-4">
                  Nous collectons les données personnelles suivantes lorsque vous utilisez notre site :
                </p>
                <ul className="list-disc list-inside text-[#64748B] space-y-2">
                  <li><strong>Formulaire de contact :</strong> nom, prénom, adresse email, numéro de téléphone, message</li>
                  <li><strong>Demande de devis :</strong> nom, prénom, adresse email, numéro de téléphone, adresse du chantier, description du projet, photos éventuelles</li>
                  <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées (via cookies)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">4. Finalités du traitement</h2>
                <p className="text-[#64748B] leading-relaxed mb-4">
                  Vos données personnelles sont collectées pour les finalités suivantes :
                </p>
                <ul className="list-disc list-inside text-[#64748B] space-y-2">
                  <li>Répondre à vos demandes de contact et de renseignements</li>
                  <li>Établir des devis personnalisés pour vos projets</li>
                  <li>Assurer le suivi de nos relations commerciales</li>
                  <li>Améliorer nos services et notre site internet</li>
                  <li>Respecter nos obligations légales et réglementaires</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">5. Base légale du traitement</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Le traitement de vos données repose sur :<br />
                  • Votre <strong>consentement</strong> lors de l'envoi d'un formulaire<br />
                  • L'<strong>exécution d'un contrat</strong> ou de mesures précontractuelles (demande de devis)<br />
                  • Notre <strong>intérêt légitime</strong> à améliorer nos services
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">6. Durée de conservation</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Vos données personnelles sont conservées pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles elles ont été collectées :<br />
                  • <strong>Données de contact :</strong> 3 ans à compter du dernier contact<br />
                  • <strong>Données de devis :</strong> 10 ans (obligations légales)<br />
                  • <strong>Données de navigation :</strong> 13 mois maximum
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">7. Destinataires des données</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Vos données personnelles sont destinées uniquement au personnel habilité de QUALIDECO. Elles ne sont en aucun cas cédées ou vendues à des tiers. Elles peuvent être transmises à nos sous-traitants techniques (hébergeur) dans le strict respect de la confidentialité.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">8. Vos droits</h2>
                <p className="text-[#64748B] leading-relaxed mb-4">
                  Conformément au RGPD, vous disposez des droits suivants :
                </p>
                <ul className="list-disc list-inside text-[#64748B] space-y-2">
                  <li><strong>Droit d'accès :</strong> obtenir la confirmation que des données vous concernant sont traitées</li>
                  <li><strong>Droit de rectification :</strong> demander la correction de données inexactes</li>
                  <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                  <li><strong>Droit à la limitation :</strong> demander la limitation du traitement</li>
                  <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
                  <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                </ul>
                <p className="text-[#64748B] leading-relaxed mt-4">
                  Pour exercer ces droits, contactez-nous à : qualideco@quali-deco.fr
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">9. Cookies</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers texte stockés sur votre appareil. Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site pourraient ne plus être disponibles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">10. Sécurité</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Notre site utilise le protocole HTTPS pour sécuriser les échanges de données.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">11. Réclamation</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d'introduire une réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) :<br />
                  <strong>CNIL</strong> - 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07<br />
                  Site web : www.cnil.fr
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">12. Mise à jour</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Cette politique de confidentialité peut être mise à jour à tout moment. La date de dernière mise à jour est indiquée ci-dessous. Nous vous invitons à la consulter régulièrement.<br /><br />
                  <strong>Dernière mise à jour :</strong> Janvier 2026
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
